// Shared PDA USA promo data used by both PromoSplash (homepage modal) and the
// Classes page promo section. Single source of truth — edit here to update both.

export const PROMOS = [
  {
    id: "fall-2026-schedule",
    eyebrow: "Now enrolling · Classes resume Aug 3, 2026",
    titlePrefix: "Join",
    titleHighlight: "PDA USA",
    titleSuffix: "— Fall 2026 to Spring 2027.",
    description:
      "In-Person classes at PDA Studio with Gowri Sathish —\nToddlers · Adults · Kids · Juniors & Teens.\nOnline classes on Zoom with Manikandan Gopinath —\nAdults · Kids · Juniors · Teens.\nStudent referral bonus available for new enrollments.",
    flyer: "/promo/pda-usa-fall-2026-schedule.jpg",
    whatsapp:
      "https://wa.me/19048078000?text=" +
      encodeURIComponent(
        "Hi Gowri! I'd like to enroll for the PDA USA Fall 2026 – Spring 2027 season. Please share details."
      ),
    email:
      "mailto:phoenixdanceacademyusa@gmail.com?subject=" +
      encodeURIComponent("Enrollment — PDA USA Fall 2026 – Spring 2027") +
      "&body=" +
      encodeURIComponent(
        "Hi PDA USA,\n\nI'd like to enroll for the Fall 2026 – Spring 2027 season.\n\nName:\nAge:\nPhone:\nClass interest (Toddlers / Adults / Kids / Juniors & Teens):\nPreferred mode (In-Person Studio / Online Zoom):\n\nThanks!"
      ),
  },
];
